import { render } from "./Wrap.vue?vue&type=template&id=062442f6"
import script from "./Wrap.vue?vue&type=script&lang=js"
export * from "./Wrap.vue?vue&type=script&lang=js"

import "./Wrap.vue?vue&type=style&index=0&id=062442f6&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__